import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import useStyles from './VerticalItem.style';
import {connect, getStore, setStore} from "trim-redux";
import AppNavLink from "../AppNavLink";
import {Box, ListItem, ListItemText} from "@mui/material";

const VerticalItem = ({level, item}) => {
    const classes = useStyles({level});
    let features = getStore('features');
    let user  = getStore('user');
    let restricted = false;
    if(!!user){
        let plan = user.plan;
        if(!!item.restrict){
            if(!plan){
                restricted = true;
            }else{
                if(!plan[item.restrict]){
                    restricted = true;
                }
            }
        }
    }else{
        restricted = true;
    }

    if(!item.feature || features[item.feature]){
        if(!restricted) {
            return (
                <>
                    {
                        item.url_type === "external" ?
                            <ListItem
                                button
                                component="a"
                                href={item.url}
                                target="_blank"
                                onClick={() => setStore({
                                    navCollapsed: false
                                })}
                                style={{paddingRight: 17 * (level + 1)}}
                                activeClassName='active'
                                className={clsx(classes.navItem, 'nav-item',!!item.disabled ? "disabled" : '')}
                                exact={item.exact}>
                                {item.icon && (
                                    <Box component='span'>
                                        {item.icon}
                                    </Box>
                                )}
                                <ListItemText
                                    primary={item.title}
                                    classes={{primary: 'nav-item-text'}}
                                />
                            </ListItem>
                            :
                            <ListItem
                                button
                                disabled={item.disabled}
                                component={!!item.disabled ? "span" :AppNavLink}
                                to={item.url}
                                onClick={() => setStore({
                                    navCollapsed: false
                                })}
                                activeClassName='active'
                                style={{paddingRight: 17 * (level + 1)}}
                                className={clsx(classes.navItem, 'nav-item',!!item.disabled ? "disabled" : '')}
                                exact={item.exact}>
                                {item.icon && (
                                    <Box component='span' mr={2}>
                                        {item.icon}
                                    </Box>
                                )}
                                <ListItemText
                                    primary={item.title}
                                    classes={{primary: 'nav-item-text'}}
                                />

                            </ListItem>
                    }

                </>

            )
        }else{
            return null
        }
    }else{
        return null
    }

};

VerticalItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
        icon: PropTypes.string,
        url: PropTypes.string,
    }),
};

VerticalItem.defaultProps = {};

const mstp = state => ({
    navCollapsed: state.navCollapsed,
});
export default connect(mstp)(React.memo(VerticalItem));
